import { useRef } from 'react';
import StripeForm from "@/components/StripeForm.jsx";

const CardPaymentModal = ({ total, modalId, lineItems, accountId, stripeReturnUrl }) => {
  const scrollRef = useRef(null);

  return (
    <div className="modal fade" id={modalId} ref={scrollRef} tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">

          <div className="modal-header">
            <h2 className="me-2">Payment Details</h2>
            <p>Total: ${(total / 100).toFixed(2)}</p>
            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <div className="modal-body mb-2">
            <StripeForm accountId={accountId} cta="Complete Purchase" lineItems={lineItems} stripeReturnUrl={stripeReturnUrl} subscription={false} scrollRef={scrollRef} />
          </div>

        </div>
      </div>
    </div>
  );
};

export default CardPaymentModal;
